<template>
    <div class="row mr-0 mr-md-3">
        <div class="col-12 d-block text-center d-md-flex justify-content-between align-items-center mb-3 pl-3 pr-3">
            <h3 class="mt-2">TUS ASIENTOS</h3>
            <Button @click="showModalBloquearAsientos()" :disabled="bloquearPasoDos || !tieneAsientos">BLOQUEAR / LIBERAR BUTACAS</Button>
        </div>
        <div class="col-12" v-if="asientos && !asientos.length && butacas && !butacas.length">
            <p class="text-center">Seleccione los asientos para continuar</p>
        </div>
        <template v-else>
            <template v-for="(asiento, index) in asientos">
                <div class="col-12 bg-secondary mb-2 py-2 d-flex justify-content-between align-items-center" :key="index" v-if="asiento.asiento">
                    <div>
                        {{ ++index }}. {{ asiento.asiento.zona_nombre }}
                        <span v-if="asiento.asiento.fila && asiento.asiento.asiento">
                            - Fila: {{ asiento.asiento.fila }} - Butaca: {{ asiento.asiento.asiento }}
                        </span>
                        <span v-else>Sin numerar</span>
                    </div>
                    <button :disabled="bloquearPasoDos" @click="eliminarAsiento(asiento.asiento)" class="btn btn-sm btn-transparent-danger ml-4">
                        <i class="fa fa-times "></i>
                    </button>
                </div>
            </template>
            <div
                v-for="(butaca, index) in butacas"
                class="col-12 col-md-10 bg-secondary mb-2 ml-4 d-flex p-1"
                :key="index"
            >
                {{ ++index }}. <div v-html="butaca.plazaName"></div>
            </div>
            <div class="col-custom" v-if="butacas && butacas.length > 0 && configuracion_valida || tieneAsientos && configuracion_valida ">
                <div v-if="teatro.carrito_varios_eventos" class="d-flex flex-row justify-content-center">
                    <template v-if="!carrito || (carrito && carrito.items_count == 0)">
                        <Button @click.prevent="continuar" class="btn btn-primary mb-2 mb-md-0 me-md-2 mr-1" style="flex: 1;">CONTINUAR COMPRA</Button>
                        <Button id="add-cart" @click="checkCarrito()" class="btn btn-secondary ml-0 ml-md-1 mr-1 mr-md-0 mb-2 mb-md-0" :disabled="disableButtonCart"><i class="fa fa-cart-plus" aria-hidden="true"></i></Button>
                    </template>
                    <Button v-else id="add-cart" @click="checkCarrito()" class="btn btn-secondary ml-0 mr-1 mr-md-0" :disabled="disableButtonCart" style="flex: 1;">AÑADIR AL CARRITO</Button>
                </div>
                <Button v-else class="btn-block" :disabled="bloquearPasoDos" @click.prevent="continuar">CONTINUAR COMPRA</Button>
            </div>
        </template>
        <BloquearButacas
            v-if="tieneAsientos && !bloquearPasoDos"
            :butacas="asientos && asientos.length > 0 ? asientos : butacas"
            @bloquearButacas="bloquearAsientos"
            @close="closeModalBloquearAsientos"
        />
    </div>
</template>

<script>
import BloquearButacas from './BloquearButacas.vue';

export default {
    props: ['asientos', 'butacas', 'configuracion_valida', 'bloquearPasoDos', 'zona', 'n_butacas'],
    data() {
        return {
            disableButtonCart: false
        }
    },
    methods: {
        checkCarrito() {
            if (this.carrito) {
                this.setItemsCarrito();
            } else {
                this.crearCarrito();
            }
        },
        crearCarrito() {
            const params = {filters: {}};

            this.$store.dispatch(this.config.getVuexAlias('taquilla.carrito.crear'), params).then(res => {
                this.setItemsCarrito();
            }).catch(error => {
                this.$toast.error(error.response.data.message);
            })
        },
        setItemsCarrito() {
            this.disableButtonCart = true;

            const params = {
                filters: {},
                cart_id: this.carrito?.id,
                asientos: this.getAsientosFormatted(),
                plazas: []
            };

            this.$store.dispatch(this.config.getVuexAlias('taquilla.carrito.add-items'), params).then(res => {
                this.$toast.success('Entradas añadidas al carrito correctamente.');
                this.$store.dispatch('TAQUILLA_CARRITO_ACTIVO');
                this.$router.push({path: "/admin/eventos"});
            }).catch(error => {
                this.$toast.error(error.response.data.message);
            }).finally(() => {
                this.disableButtonCart = false;
            });
        },
        getAsientosFormatted() {
            let asientos = [];

            this.asientos.map(asiento => {
                asientos.push({
                    precio: {
                        id: asiento.precios[0].id
                    },
                    row: asiento.asiento?.fila,
                    seat: asiento.asiento?.asiento,
                    units: 1,
                    event_id: this.evento_id,
                    event_session_id: this.sesion_id,
                    region_id: asiento.asiento?.zona_id
                })
            });

            return asientos;
        },
        continuar() {
            this.$emit('continuar');
        },
        eliminarAsiento(asiento) {
            this.$emit('eliminar-asiento', asiento);
        },
        showModalBloquearAsientos() {
            this.$modal.show('bloquearButacas');
        },
        closeModalBloquearAsientos() {
            this.$modal.hide('bloquearButacas');
        },
        bloquearAsientos(concepto, etiqueta) {
            if (this.url.includes('eventos')) {
                var asientosFormatted = [];
    
                if (this.asientos.length > 0) {
                    this.asientos.forEach(asiento => {
                        var region_id = asiento.asiento.zona_id;
                        var row = asiento.asiento.fila;
                        var seat = asiento.asiento.asiento;
                        var zona_nombre = asiento.asiento.zona_nombre;
    
                        asientosFormatted.push({
                            region_id: region_id,
                            row: row,
                            seat: seat,
                            zona_nombre: zona_nombre
                        });
                    });
                }
    
                const params = {
                    filters: {},
                    asientos: asientosFormatted,
                    concepto: concepto,
                    evento_id: this.$route.params.evento_id,
                    sesion_id: this.$route.params.sesion_id,
                    zona_id: this.zona.id,
                    n_butacas: this.n_butacas,
                    plazasSeleccionadas: []
                };
    
                if(etiqueta){
                    params.etiqueta_bloqueo_id = etiqueta.id;
                }
    
                this.$store.dispatch(this.config.getVuexAlias('back.events.sesiones.bloquear.asientos'), params).then(res => {
                    this.$emit('update');
                });
            } else {
                const seats = this.butacas.length > 0 ? this.butacas : this.asientos;
                this.$emit('bloquearAsientosVenta', concepto, etiqueta, seats);
            }

            this.closeModalBloquearAsientos();
        }
    },
    computed: {
        url() {
            return window.location.href;
        },
        tieneAsientos() {
            return (this.asientos && this.asientos.length > 0) || (this.butacas && this.butacas.length > 0);
        },
        teatro() {
            return this.$store.getters.getTeatro;
        },
        carrito() {
            return this.$store.getters.getCarritoActivo;
        },
        evento_id() {
            return this.$route.params.evento_id;
        },
        sesion_id() {
            return this.$route.params.sesion_id;
        }
    },
    components: {
        BloquearButacas
    }
}
</script>
<style>
.btn-transparent-danger {
  background-color: transparent !important ; 
  border: none; 
}

.btn-transparent-danger:hover {
  color: #fff !important;
  background-color: #dc3545 !important;
  border-color: #dc3545;
  box-shadow: none;
}
.col-custom{
    position: relative;
    width: 100%;
}
</style>
